module.exports = __webpack_public_path__ + "static/img/ic-17.84de2e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-17.png
// module id = 1OS9
// module chunks = 1